import React from 'react'
import i18next from 'i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { TransactionType } from 'types/transaction/TransactionType'

interface CryptoDepositProps {
  amountWithCurrency: string
  transactionDate: string
  transactionHash: string
  transactionDepositCryptoUUID: string
  sourceAddress: string
}

const CryptoDeposit = ({
  amountWithCurrency,
  transactionDate,
  transactionHash,
  transactionDepositCryptoUUID,
  sourceAddress,
}: CryptoDepositProps) => {
  return (
    <>
      <DataListItem
        id="amount-with-currency"
        testId="amount-with-currency"
        title={i18next.t('transactions.sideBar.paymentInAmountReceived')}
        body={amountWithCurrency}
      />
      <DataListItem
        id="transaction-hash"
        testId="transaction-hash"
        title={i18next.t('hash')}
        body={ellipseMiddleText(transactionHash, 20, 10)}
        copyText={transactionHash}
        {...(transactionHash.includes(TransactionType.OFF_CHAIN) && {
          externalLink: process.env.OFF_CHAIN_INFO_LINK,
        })}
      />
      <DataListItem
        id="transaction-deposit-crypto-uuid"
        testId="transaction-deposit-crypto-uuid"
        title={i18next.t('transactions.sideBar.uuid')}
        body={ellipseMiddleText(transactionDepositCryptoUUID, 20, 10)}
        copyText={transactionDepositCryptoUUID}
      />
      <DataListItem
        id="transaction-date"
        testId="transaction-date"
        title={i18next.t('date')}
        body={transactionDate}
      />

      {sourceAddress && (
        <Box paddingT={20}>
          <p className="text-h4 text-foreground-prominent">{i18next.t('senderDetails')}</p>

          <DataListItem
            id="source-address"
            testId="source-address"
            title={i18next.t('transactions.sideBar.sourceAddress')}
            body={ellipseMiddleText(sourceAddress, 20, 10)}
            copyText={sourceAddress}
          />
        </Box>
      )}
    </>
  )
}

export default CryptoDeposit
